const getters = {
  dict: state => state.global.dict
}

export default getters
